module.exports = __webpack_public_path__ + "img/ico-feature_1.3843f271.svg";